import  React, {useState} from "react";
import Button from "@mui/material/Button";


import AddLaabhPartner from "../component/UserManagement.js/AddLaabhPartner";
import useAddLaabhPartner from "../hooks/useAddLaabhPartner";
import useLaabhPartner from "../hooks/useLaabhPartners";
import useAddDemoLaabhPartner from "../hooks/DemoPartner/useAddDemoLaabhPartner";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";


export default function BasicModal( {getAllDistributorList, selectedZoneName, selectedZoneId, value, getDemoLpList, areaNameList, areaData, setAreaData}) {

  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [pendingFormData, setPendingFormData] = useState(null);


  // console.log(value, "value1111")
  
  const postAddLaabhPartner = useAddLaabhPartner();
  const getmapLaabhPartnerList = useLaabhPartner(); 
  const addDemoLaabhPartner = useAddDemoLaabhPartner();

  const handleConfirmYes = async () => {
    setOpenConfirmDialog(false);

    const finalResponse = await postAddLaabhPartner({
      ...pendingFormData,
      is_confirmation: true,
    });

    if (finalResponse.status === 200) {
      toast.success(finalResponse.message);
      await getAllDistributorList();
      await getmapLaabhPartnerList({ zone_id: pendingFormData.zone_id });
    } else {
      toast.error(finalResponse.message);
    }

    setPendingFormData(null);
  };

  const handleConfirmNo = () => {
    setOpenConfirmDialog(false);
    setPendingFormData(null);
  };


  const handleAddDeliveryBoy = async(formData) => {
    if(value === "1"){
      const data = await postAddLaabhPartner(formData);
      if(data?.status === 409){
          setConfirmMessage(data?.message);
          setPendingFormData(formData);
          setIsDialogOpen(false)
          setOpenConfirmDialog(true);
      }else if(data?.status === 200){
        toast.success(data.message);
        await getAllDistributorList();
        const param = {
          zone_id: formData.zone_id,
        };
        await getmapLaabhPartnerList(param);
      }else{
        toast.error(data.message);
      }
    }else{
      await addDemoLaabhPartner(formData, areaData);
      await getDemoLpList();
      const param = {
        zone_id: formData.zone_id
      }
      await getmapLaabhPartnerList(param);
    }
  };


  return (
    <div>
      <Button
        onClick={() => setIsDialogOpen(true)}
        sx={{ color: "white", textTransform: "none" }}
      >
        Add
      </Button>
      <AddLaabhPartner
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSubmit={handleAddDeliveryBoy}
        selectedZoneName={selectedZoneName}
        selectedZoneId={selectedZoneId}
        value={value}
        areaNameList={areaNameList}
        areaData={areaData}
        setAreaData={setAreaData}
      />

      <Dialog open={openConfirmDialog} onClose={handleConfirmNo}>
        <DialogTitle>Confirmation</DialogTitle>

        <DialogContent>
          <DialogContentText>{confirmMessage}</DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleConfirmNo} color="error">
            No
          </Button>

          <Button
            onClick={handleConfirmYes}
            color="primary"
            variant="contained"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
